import styled from 'styled-components';

import {
  Image as SemanticImage,
} from 'semantic-ui-react';

import {
  Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  margin-bottom: 25px;
`;

export const AcceptedWhenRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
`;

export const AcceptedWhenTitle = styled(TextLayoutComponent.Bold)`
  margin-bottom: 3px;
`;

export const AcceptedWhenTimestamp = styled(TextLayoutComponent)`
`;

export const ConsentFormList = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
`;

export const ConsentFormLine = styled.div`
  display: flex;
`;

export const ConsentFormTitle = styled(TextLayoutComponent)`
  margin-right: 40px;
  flex: 1;
  text-align: left;
`;

export const ConsentFormLink = styled.a`
`;

export const Text = styled(TextLayoutComponent)`
  text-align: left;
`;

export const Image = styled(SemanticImage)`
  width: 120px;
`;

export const UserInterviewsMessage = styled(TextLayoutComponent.Bold)`
  display: flex;
  margin-top: 15px;
  align-items: center;
  gap: 1em;
  line-height: 0;
  text-align: left;
  flex-wrap: wrap;
`;
